"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ITwinName.js.map